import styled from "styled-components";
import { MEDIA_Q } from "../../../config/constants/css";

export const StyledProfilePrimaryDetailsWrapper = styled.div`
  display: grid;
  gap: 10px;
  width: 100%;
  grid-template-columns: 1fr;
  pointer-events: none;

  ${MEDIA_Q.SM} {
    grid-template-columns: 1fr 1fr;
  }
  ${MEDIA_Q.LG} {
    grid-template-columns: 1fr 1fr 1fr;
  }
  ${MEDIA_Q.XL} {
    grid-template-columns: 1fr 1fr 1fr 1fr;
  }
`;

export const StyledDetailItemWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const StyledPrimaryDetailsWrapper = styled.div`
  box-shadow: 0px 5px 5px -5px ${(p) => p.theme.shadow};
  margin-bottom: 20px;
`;

export const StyledNameContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding: 14px;
  align-items: start;
  gap: 14px;
`;

export const StyledUserDetailsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
`;

export const StyledProfileIconWrapper = styled.div`
  padding: 14px;
  border-radius: 4px;
  border: 1px solid ${(p) => p.theme.border};
`;

export const StyledProfileIcon = styled.img`
  height: 70px;
  min-width: 70px;
`;
